import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AssessmentOutlined,
  AutoStoriesOutlined,
  FolderOpenOutlined,
  HandshakeOutlined,
  SupportAgentOutlined,
} from '@mui/icons-material';
import { Authorize, NavigateLinks } from '@/components';
import { COMMERCE_ROLE_GROUPS } from '@/components/security/AppRoles';
import { icons } from '@/assets';
import { ATC_AVAILABLE } from '@/config/country';
import VisitsReportDialog from './pages/Reports/components/VisitsReportDialog';
import { businessCommercesPageBreadcrumbs } from './config/breadcrumbs';

export const BusinessCommerces = () => {
  const navigate = useNavigate();
  const [isReportOpen, setIsReportOpen] = useState(false);
  const breadcrumbs = useMemo(
    () => businessCommercesPageBreadcrumbs(navigate),
    [navigate]
  );

  return (
    <section className='w-full h-full flex flex-col gap-8 p-5'>
      <NavigateLinks actualPage='Sistema de envíos' breadcrumbs={breadcrumbs} />
      <section className='w-full h-full flex flex-col items-center'>
        <ul className='h-full w-full max-w-[calc(6*200px+5*50px)] grid grid-cols-[repeat(auto-fit,200px)] content-center justify-center gap-[50px]'>
          <li
            className='w-[200px] p-[25px] aspect-[4/3] flex flex-col justify-between items-center bg-white rounded-[5px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-transform duration-[0.25s] cursor-pointer overflow-hidden hover:scale-105'
            onClick={() => navigate('/business-commerces/shippings')}
          >
            <img
              src={icons.preparePackage}
              alt='Icono de pedidos'
              className='h-[90px] object-contain'
            />
            <p className='text-center'>Envíos</p>
          </li>
          <li
            className='w-[200px] p-[25px] aspect-[4/3] flex flex-col justify-between items-center bg-white rounded-[5px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-transform duration-[0.25s] cursor-pointer overflow-hidden hover:scale-105'
            onClick={() => navigate('/business-commerces/jobs')}
          >
            <div className='mt-2 flex h-[82px] w-[82px] items-center justify-center rounded-2xl bg-gradient-to-br from-sky-400 to-sky-600 text-white shadow-lg shadow-sky-200'>
              <FolderOpenOutlined sx={{ fontSize: 44 }} />
            </div>
            <p className='text-center'>Mis archivos</p>
          </li>
          {ATC_AVAILABLE && (
            <li
              className='w-[200px] p-[25px] aspect-[4/3] flex flex-col justify-between items-center bg-white rounded-[5px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-transform duration-[0.25s] cursor-pointer overflow-hidden hover:scale-105'
              onClick={() => navigate('/business-commerces/cases')}
            >
              <div className='mt-2 flex h-[82px] w-[82px] items-center justify-center rounded-2xl bg-gradient-to-br from-violet-400 to-violet-600 text-white shadow-lg shadow-violet-200'>
                <SupportAgentOutlined sx={{ fontSize: 44 }} />
              </div>
              <p className='text-center'>Mis casos</p>
            </li>
          )}
          <li
            className='w-[200px] p-[25px] aspect-[4/3] flex flex-col justify-between items-center bg-white rounded-[5px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-transform duration-[0.25s] cursor-pointer overflow-hidden hover:scale-105'
            onClick={() => navigate('/business-commerces/meli-access')}
          >
            <div className='mt-2 flex h-[82px] w-[82px] items-center justify-center rounded-2xl bg-gradient-to-br from-yellow-300 to-amber-400 text-[#2D3277] shadow-lg shadow-amber-200'>
              <HandshakeOutlined sx={{ fontSize: 44 }} />
            </div>
            <p className='text-center'>Mercado Libre</p>
          </li>
          <Authorize permission={[...COMMERCE_ROLE_GROUPS.reports]}>
            <li
              className='w-[200px] p-[25px] aspect-[4/3] flex flex-col justify-between items-center bg-white rounded-[5px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-transform duration-[0.25s] cursor-pointer overflow-hidden hover:scale-105'
              onClick={() => setIsReportOpen(true)}
            >
              <div className='mt-2 flex h-[82px] w-[82px] items-center justify-center rounded-2xl bg-gradient-to-br from-emerald-400 to-emerald-600 text-white shadow-lg shadow-emerald-200'>
                <AssessmentOutlined sx={{ fontSize: 44 }} />
              </div>
              <p className='text-center'>Reporte de visitas</p>
            </li>
          </Authorize>
          <li
            className='group relative w-[200px] p-[25px] aspect-[4/3] flex flex-col justify-between items-center bg-white rounded-[5px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-all duration-[0.25s] cursor-pointer overflow-hidden hover:scale-105 hover:shadow-[0_14px_35px_rgba(249,115,22,0.18)]'
            onClick={() => navigate('/business-commerces/support-material')}
          >
            <div className='mt-2 flex h-[82px] w-[82px] items-center justify-center rounded-2xl bg-gradient-to-br from-orange-400 to-orange-600 text-white shadow-lg shadow-orange-200 transition-transform duration-300 group-hover:-rotate-3 group-hover:scale-105'>
              <AutoStoriesOutlined sx={{ fontSize: 44 }} />
            </div>
            <p className='text-center font-medium'>Material de apoyo</p>
          </li>
        </ul>
      </section>
      <VisitsReportDialog
        open={isReportOpen}
        onClose={() => setIsReportOpen(false)}
      />
    </section>
  );
};

export default BusinessCommerces;
